import StoreName from './StoreName';
export default StoreName;
